import React, {useState} from 'react'
import {Route, Redirect, useLocation, useHistory} from 'react-router-dom'
import {useSettings} from './Settings'
import PageTitle from '../components/PageTitle/PageTitle'
import queryString from 'query-string'

const AuthorizedRoute = ({component, checkParams, ...rest}) => {
    const {logged} = useSettings()
    let location = useLocation()
    let history = useHistory()

    if (checkParams) {
        const params = queryString.parse(location.search)
        if (params['open-on-section']) 
            sessionStorage.setItem(
                'openOnSection',
                String(params['open-on-section'])
            )

        if (params['cliententityid']) {
            sessionStorage.setItem(
                'sessionClientEntityId',
                String(params['cliententityid'])
            )
            history.replace(location.pathname)
        }
        if (params['client-entity-id']) {
            sessionStorage.setItem(
                'sessionClientEntityId',
                String(params['client-entity-id'])
            )
            if (params['parent-client-entity-id'])
                sessionStorage.setItem(
                    'sessionParentClientEntityId',
                    String(params['parent-client-entity-id'])
                )  
            history.replace(location.pathname)
        }
    }

    const loginPath =
        process.env.REACT_APP_ISMYACCOUNT === 'yes' ? '/login-my-account' : '/login'

    if (logged !== true) return <Redirect to={loginPath} />
    return (
        <Route
            {...rest}
            render={props => <PageTitle {...props} component={component} />}
        />
    )
}

export default AuthorizedRoute
